import { useState, useRef, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import ExpandMore from '@mui/icons-material/ExpandMore'

const RoleSelect = ({ name, value, onChange, className = '' }) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  const ref = useRef(null)

  const options = [
    { value: 'parent', labelKey: 'auth.roleParent' },
    { value: 'school_admin', labelKey: 'auth.roleSchoolAdmin' },
  ]

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false)
    }
    if (open) {
      document.addEventListener('mousedown', handleClickOutside)
      return () => document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [open])

  const selected = options.find((o) => o.value === value) || options[0]

  const handleSelect = (option) => {
    onChange({ target: { name, value: option.value } })
    setOpen(false)
  }

  return (
    <div ref={ref} className={`relative ${className}`}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center justify-between rounded-md border border-gray-300 bg-white px-3 py-2.5 text-left text-sm text-gray-900 transition-colors hover:border-gray-400 focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-500 md:px-4 md:py-2.5 md:text-base"
        aria-expanded={open}
        aria-haspopup="listbox"
        aria-label={t('auth.role')}
      >
        <span>{t(selected.labelKey)}</span>
        <ExpandMore
          className={`shrink-0 text-gray-500 transition-transform ${open ? 'rotate-180' : ''}`}
          sx={{ fontSize: 22 }}
        />
      </button>
      {open && (
        <ul
          role="listbox"
          className="absolute left-0 right-0 top-full z-50 mt-1 max-h-48 overflow-auto rounded-lg border border-gray-200 bg-white py-1 shadow-lg"
        >
          {options.map((option) => (
            <li
              key={option.value}
              role="option"
              aria-selected={value === option.value}
              onClick={() => handleSelect(option)}
              className={`cursor-pointer px-3 py-2.5 text-sm text-gray-900 transition-colors md:px-4 md:text-base ${
                value === option.value
                  ? 'bg-primary-50 font-medium text-primary-700'
                  : 'hover:bg-gray-50'
              }`}
            >
              {t(option.labelKey)}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default RoleSelect
